import { Factory } from '../../services/Factory';

interface IBarChartScope extends angular.IScope {
  data: any;
  formatY: Function;
  width: string;
  height: string;
}

interface IBarChartAttributes extends angular.IAttributes {
}

export class BarChart implements angular.IDirective {
  public restrict: string = 'E';
  public link: (scope: IBarChartScope, element: angular.IAugmentedJQuery, attrs: IBarChartAttributes) => void;
  public template: string;
  public scope = {
    data: '=',
    formatY: '&',
    width: '@',
    height: '@'
  };

  constructor() {
    this.template = `<div></div>`;
    this.link = (scope: IBarChartScope, element: angular.IAugmentedJQuery, attrs: IBarChartAttributes) => {
        scope.$watch("data", () => {
          if (!scope.data) {
            return;
          }

          let max = -1;
          let empty = true;

          scope.data.slice(1).forEach((d: _.List<number>) => max = Math.max(max, _.max(d, v => v || 0)));

          if (max >= 0) {
            empty = false;
          }

          c3.generate({
            bindto: element[0],
            size: {
              height: scope.height ? +scope.height : 460,
              width: +scope.width
            },
            data: {
              x: scope.data.length > 0 ? scope.data[0][0] : 'x',
              columns: scope.data,
              type: 'bar',
              empty: {
                label: {
                  text: "No Data"
                }
              }
            },
            bar: {
              width: {
                ratio: 0.3
              }
            },
            color: {
              pattern: ['#0099CC', '#FF8800', '#007E33', '#3F729B']
            },
            axis: {
              x: {
                show: !empty,
                localtime: false,
                type: 'timeseries',
                tick: {
                  format: '%Y-%m-%d',
                  culling: {
                    max: 50
                  },
                  rotate: 50,
                  multiline: false
                }
              },
              y: {
                show: !empty,
                min: 0,
                max: Math.max(100000000, max),
                padding: {
                  bottom: 0
                },
                tick: {
                  format: r => scope.formatY()(r)
                }
              }
            },
            grid: {
              x: {
                show: false
              },
              y: {
                show: false
              }
            },
            zoom: {
              enabled: false
            },
            subchart: {
              show: false
            }
          });
        });
    }
  }
}

frontendApp.directive("iioBarChart", [Factory.Create(BarChart)]);
